const API_BASE = process.env.REACT_APP_USPS_API || 'https://agent.relufox.ai/usps';

// Validate URL to prevent SSRF attacks
const validateEndpoint = (endpoint) => {
  if (!endpoint || typeof endpoint !== 'string') {
    throw new Error('Invalid endpoint');
  }
  // Only allow specific safe endpoints
  const allowedEndpoints = ['/health', '/ops', '/kpis', '/package/', '/sql'];
  const isAllowed = allowedEndpoints.some(allowed => 
    endpoint === allowed || endpoint.startsWith(allowed)
  );
  if (!isAllowed) {
    throw new Error('Endpoint not allowed');
  }
  return endpoint;
};

class USPSApi {
  async get(endpoint) {
    const validatedEndpoint = validateEndpoint(endpoint);
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30000);
    
    try {
      const response = await fetch(`${API_BASE}${validatedEndpoint}`, {
        signal: controller.signal
      });
      clearTimeout(timeoutId);
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`API Error ${response.status}: ${errorData.detail || response.statusText}`);
      }
      
      const data = await response.json();
      console.log(`API ${endpoint}:`, { 
        length: Array.isArray(data) ? data.length : 'not array',
        sample: Array.isArray(data) ? data[0] : data,
        error: data.error || data.detail
      });
      
      return data;
    } catch (error) {
      clearTimeout(timeoutId);
      if (error.name === 'AbortError') {
        throw new Error('Request timeout');
      }
      throw error;
    }
  }

  async getHealth() {
    return this.get('/health');
  }

  async getOps() {
    return this.get('/ops');
  }

  async getKPIs(startDate, endDate) {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    params.append('_t', Date.now()); // Cache buster
    return this.get(`/kpis?${params}`);
  }

  async getPackage(packageId) {
    return this.get(`/package/${packageId}`);
  }

  async runSQL(query) {
    return this.get(`/sql?q=${encodeURIComponent(query)}`);
  }
}

const uspsApiInstance = new USPSApi();
export default uspsApiInstance;